// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { QuartelActions, QuartelActionTypes } from '../_actions/quartel.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Quartel} from '../_models/quartel.model';

// tslint:disable-next-line:no-empty-interface
export interface QuartelState extends EntityState<Quartel> {
    listLoading: boolean;
    actionsloading: boolean;
    totalCount: number;
    lastCreatedQuartelId: number;
    lastUpdatedQuartelId: number;
    lastDeletedQuartelId: number;
    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Quartel> = createEntityAdapter<Quartel>();

export const initialQuartelState: QuartelState = adapter.getInitialState({
    listLoading: false,
    actionsloading: false,
    totalCount: 0,
    lastQuery:  new QueryParamsModel({}),
    lastCreatedQuartelId: undefined,
    lastUpdatedQuartelId: undefined,
    lastDeletedQuartelId: undefined,
    showInitWaitingMessage: true
});

export function quartelsReducer(state = initialQuartelState, action: QuartelActions): QuartelState {
    switch  (action.type) {
        case QuartelActionTypes.QUARTEL_ADDED: return adapter.addOne(action.payload.quartel, {
            ...state, lastCreatedQuartelId: action.payload.quartel.id
        });
        case QuartelActionTypes.QUARTEL_EDITED: return adapter.updateOne(action.payload.partialQuartel, 
            {...state, lastUpdatedQuartelId: action.payload.quartel.id});
        case QuartelActionTypes.QUARTEL_PAGE_LOADED: return adapter.addMany(action.payload.quartels, {
            ...initialQuartelState,
            totalCount: action.payload.totalCount,
            lastQuery: action.payload.page,
            listLoading: false,
            showInitWaitingMessage: false
        });
        case QuartelActionTypes.QUARTEL_ALL_LOADED: return adapter.addMany(action.payload.quartels, {
            ...initialQuartelState,
            listLoading: false,
            showInitWaitingMessage: false
        });
        case QuartelActionTypes.QUARTEL_DELETED: return adapter.removeOne(action.payload.id, 
            {...state, lastDeletedQuartelId: action.payload.id});
        // case UserActionTypes.UsersPageCancelled: return {
        //     ...state, listLoading: false, lastQuery: new QueryParamsModel({})
        // };
        default: return state;
    }
}

export const getQuartelState = createFeatureSelector<QuartelState>('quartels');

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();